// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsRecommendationCard_card__77Onf","container":"NewsRecommendationCard_container__b3owW","subheading":"NewsRecommendationCard_subheading__gkICx"};